import React, { useEffect, useMemo } from 'react';

import { forceCheck } from 'react-lazyload';
import { useTranslator, useCurrentLanguage } from 'tradera-lang';
import { loadingStates } from './recommendations.jsx';
import { ItemCard } from '@tradera/blueprint/components/lib/item-card';
import { lazyLoadSettings } from 'tradera-components/item-card/config';
import { getItemCardText } from 'tradera-components/item-card/helpers';
import '@tradera/blueprint/components/lib/item-card.css';
import 'tradera-components/item-card/layout.scss';

const RecommendationsView = props => {
    const {
        children,
        infiniteScrollEnabled,
        isLoggedIn,
        itemIds,
        items,
        itm,
        loadingState,
        onQuickView,
        preferredCurrency,
        setLoadingTriggerRef,
        toggleWishlist
    } = props;
    const { ErrorMessage, LoadingSymbol, NoMoreItemsMessage, Title } = props;
    const { t } = useTranslator();
    const { language } = useCurrentLanguage();
    const itemCardText = useMemo(() => getItemCardText(t), [t]);

    const loadingTriggerStyle = {
        height: '1px',
        width: '1px',
        margin: '1px',
        display: loadingState === loadingStates.loading ? 'none' : 'block'
    };

    useEffect(() => {
        // Hack to ensure loaded item cards have lazy loading triggered after loading
        if (loadingState === loadingStates.ready) {
            const checkLoadedTimeout = setTimeout(forceCheck, 500);
            return () => clearTimeout(checkLoadedTimeout);
        }
    }, [loadingState]);

    return (
        <div className="product-recommendations container text-inter">
            {loadingState === loadingStates.ready && Title}
            <section className="item-card-layout layout-grid row">
                {itemIds.map((itemId, index) => (
                    <div key={index} className="item-card-container px-3 pb-2">
                        <ItemCard
                            ready={!!items[itemId].itemUrl}
                            item={items[itemId]}
                            isLoggedIn={isLoggedIn}
                            lazy={lazyLoadSettings}
                            itm={itm}
                            onAddToWishlist={toggleWishlist}
                            onRemoveFromWishlist={toggleWishlist}
                            onQuickView={onQuickView}
                            preferredCurrency={preferredCurrency}
                            text={itemCardText}
                            language={language}
                        />
                    </div>
                ))}
            </section>
            {loadingState === loadingStates.loading && LoadingSymbol}
            {loadingState === loadingStates.error && ErrorMessage}
            {loadingState === loadingStates.end && NoMoreItemsMessage}
            {infiniteScrollEnabled &&
                !(
                    loadingState === loadingStates.end ||
                    loadingState === loadingStates.error
                ) && (
                    <div
                        ref={ref => setLoadingTriggerRef(ref)}
                        style={loadingTriggerStyle}
                        data-recommendations-infinite-scroll-trigger=""
                    />
                )}
            {loadingState === loadingStates.ready && children}
        </div>
    );
};

export default RecommendationsView;
